// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__4+BnD"};